import { MODULE_NAME } from './constants';
import reducer from './reducer';
import { createReduxModule } from '../../utils/reduxUtils';

export * from './actions';
export * from './selectors';
export * from './types';

export default createReduxModule(MODULE_NAME, reducer);
